import React from 'react';
import { Link } from 'react-router-dom';

const companyLinks = [
  {
    name: "À propos",
    path: "/a-propos",
    external: false
  },
  {
    name: "Nos projets",
    path: "/projets",
    external: false
  },
  {
    name: "Collab",
    path: "/collab",
    external: false
  },
  {
    name: "Blog",
    path: "https://orcsys.fr/votre-industrie/",
    external: true
  },
  {
    name: "Contact",
    path: "/contact",
    external: false
  }
];

const CompanyLinks = () => {
  return (
    <div>
      <h3 className="text-lg font-semibold mb-4">L'entreprise</h3>
      <ul className="space-y-2">
        {companyLinks.map((link) => (
          <li key={link.path}>
            {link.external ? (
              <a
                href={link.path}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-orcsys-500 transition-colors"
              >
                {link.name}
              </a>
            ) : (
              <Link
                to={link.path}
                className="text-gray-600 hover:text-orcsys-500 transition-colors"
              >
                {link.name}
              </Link>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CompanyLinks; 